import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ba7b88ca&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ba7b88ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7b88ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba7b88ca')) {
      api.createRecord('ba7b88ca', component.options)
    } else {
      api.reload('ba7b88ca', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ba7b88ca&scoped=true&", function () {
      api.rerender('ba7b88ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KL4bT1PVKB6D/JS/comp/PopupBox.vue"
export default component.exports